import { Component, Attribute, Input } from '@angular/core';

@Component({
    selector: 'finder-button',
    templateUrl: './finder-button.component.html',
    styleUrls: ['./finder-button.component.scss']
})
export class FinderButtonComponent {
    @Input() public disabled: boolean;
    @Input() public href: string;
    @Input() public linkId: string;
    @Input() public theme: string;
    @Input() public fitText: boolean;
    @Input() public selected: boolean;
    @Input() public fullWidth: boolean;

    constructor() { }
}
